import { captureObservabilityError } from '@psyomics/ui-common';
import { useEffect, useState } from 'react';

import { Button, IButtonProps } from '../button/button';

const COPIED_TIMEOUT_MS = 2000;

type CopyButtonProps = Omit<IButtonProps, 'children' | 'onClick'> & {
  readonly value: string;
  readonly copyLabel: string;
  readonly copiedLabel: string;
};

const CopyButton = ({
  value,
  copyLabel,
  copiedLabel,
  appearance = 'secondary',
  size = 'sm',
  ...props
}: CopyButtonProps) => {
  const [copyCount, setCopyCount] = useState(0);
  const copied = copyCount > 0;

  useEffect(() => {
    if (copyCount === 0) return;
    const timer = setTimeout(() => setCopyCount(0), COPIED_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [copyCount]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (err) {
      captureObservabilityError(err);
      return;
    }
    setCopyCount((count) => count + 1);
  };

  return (
    <Button appearance={appearance} onClick={handleCopy} size={size} type="button" {...props}>
      {copied ? copiedLabel : copyLabel}
    </Button>
  );
};

export { CopyButton };
